import { Category, categoryToImage } from '@/utils/defines/ItemCode'

export default {
	watch: {},
	beforeDestroy() {
		document.body.classList.remove('modal-open')
	},
	data() {
		return {
			isShow: false,
			folded: true,
			sampleList: [
				{
					id: 1,
					date: '2021.06.09',
					title: '4-Bromobenzeonitrile',
					company: 'DAEJUNG(대정)',
					subname: 'anhydrous 99.8%',
					type: 1,
					use: true,
					auto: true,
					new: true,
					location: '그린촉매연구실',
					number: 'L1-Default-5',
					area: '실험관 201호',
					storage: '냉장보관함',
					period: 60,
				},
				{
					id: 2,
					date: '2021.06.09',
					title: 'Hydrochloric acid',
					company: 'Sigma-Aldrich(Merck)',
					capacity: '250g',
					type: 2,
					use: false,
					auto: true,
					location: '그린촉매연구실',
					number: 'L1-Default-5',
					area: '실험관 201호',
					storage: '냉장보관함',
					period: 60,
				},
				{
					id: 3,
					date: '2021.06.09',
					title: '4-Bromobenzeonitrile',
					subname: 'anhydrous 99.8%',
					type: 3,
					use: true,
					auto: true,
					location: '그린촉매연구실',
					number: 'L1-Default-5',
					area: '실험관 201호',
					storage: '냉장보관함',
					period: 60,
				},
				{
					id: 4,
					date: '2021.06.09',
					title: '4-Bromobenzeonitrile',
					subname: 'anhydrous 99.8%',
					type: 4,
					use: true,
					auto: false,
					location: '그린촉매연구실',
					number: 'L1-Default-5',
					area: '실험관 201호',
					storage: '냉장보관함',
					period: 60,
				},
				{
					id: 5,
					date: '2021.06.08',
					title: '4-Bromobenzeonitrile',
					company: 'DAEJUNG(대정)',
					subname: 'anhydrous 99.8%',
					type: 5,
					use: true,
					auto: true,
					location: '그린촉매연구실',
					number: 'L1-Default-5',
					area: '실험관 201호',
					storage: '냉장보관함',
					period: 60,
				},
				{
					id: 6,
					date: '2021.06.08',
					title: 'Hydrochloric acid',
					company: 'Sigma-Aldrich(Merck)',
					capacity: '250g',
					type: 6,
					use: false,
					auto: true,
					location: '그린촉매연구실',
					number: 'L1-Default-5',
					area: '실험관 201호',
					storage: '냉장보관함',
					period: 60,
				},
				{
					id: 7,
					date: '2021.06.08',
					title: '4-Bromobenzeonitrile',
					subname: 'anhydrous 99.8%',
					type: 7,
					use: true,
					auto: true,
					location: '그린촉매연구실',
					number: 'L1-Default-5',
					area: '실험관 201호',
					storage: '냉장보관함',
					period: 60,
				},
				{
					id: 8,
					date: '2021.06.08',
					title: '4-Bromobenzeonitrile',
					subname: 'anhydrous 99.8%',
					type: 8,
					use: true,
					auto: false,
					location: '그린촉매연구실',
					number: 'L1-Default-5',
					area: '실험관 201호',
					storage: '냉장보관함',
					period: 60,
				},
				{
					id: 9,
					date: '2021.06.08',
					title: '4-Bromobenzeonitrile',
					company: 'DAEJUNG(대정)',
					subname: 'anhydrous 99.8%',
					type: 9,
					use: true,
					auto: true,
					location: '그린촉매연구실',
					number: 'L1-Default-5',
					area: '실험관 201호',
					storage: '냉장보관함',
					period: 60,
				},
				{
					id: 10,
					date: '2021.06.08',
					title: 'Hydrochloric acid',
					company: 'Sigma-Aldrich(Merck)',
					capacity: '250g',
					type: 10,
					use: false,
					auto: true,
					location: '그린촉매연구실',
					number: 'L1-Default-5',
					area: '실험관 201호',
					storage: '냉장보관함',
					period: 60,
				},
				{
					id: 11,
					date: '2021.06.08',
					title: '4-Bromobenzeonitrile',
					subname: 'anhydrous 99.8%',
					type: 11,
					use: true,
					auto: true,
					location: '그린촉매연구실',
					number: 'L1-Default-5',
					area: '실험관 201호',
					storage: '냉장보관함',
					period: 60,
				},
				{
					id: 12,
					date: '2021.06.08',
					title: '4-Bromobenzeonitrile',
					subname: 'anhydrous 99.8%',
					type: 12,
					use: true,
					auto: false,
					location: '그린촉매연구실',
					number: 'L1-Default-5',
					area: '실험관 201호',
					storage: '냉장보관함',
					period: 60,
				},
			],
			typeList: [
				{
					id: 1,
					type: Category.REAGENT,
					name: '시약',
					image: 'category-img-reagent.svg',
				},
				{
					id: 2,
					type: Category.MADE_REAGENT,
					name: '제조시약',
					image: 'category-img-made-reagent.svg',
				},
				{
					id: 3,
					type: Category.RAW_MATERIAL,
					name: '원료',
					image: 'category-img-raw-material.svg',
				},
				{
					id: 4,
					type: Category.MADE_RAW_MATERIAL,
					name: '제조원료',
					image: 'category-img-made-raw-material.svg',
				},
				{
					id: 5,
					type: Category.STANDARD,
					name: '표준품',
					image: 'category-img-standard.svg',
				},
				{
					id: 6,
					type: Category.GAS,
					name: '가스',
					image: 'category-img-gas.svg',
				},
				// {
				// 	id: 7,
				// 	type: Category.Tu,
				// 	name: '튜브/바이알(샘플)',
				// 	image: 'type-tube.svg',
				// },
				{
					id: 8,
					type: Category.CHROMATOGRAPHY,
					name: '분석용칼럼',
					image: 'category-img-chromatography.svg',
				},
				{
					id: 9,
					type: Category.EQUIPMENT,
					name: '기계',
					image: 'category-img-equipment.svg',
				},
				{
					id: 10,
					type: Category.TOOL,
					name: '기구',
					image: 'category-img-experiment.svg',
				},
				{
					id: 11,
					type: Category.PROTECTION,
					name: '보호구',
					image: 'category-img-protection.svg',
				},
				{
					id: 12,
					type: Category.ETC,
					name: '소모품',
					image: 'category-img-etc.svg',
				},
				// { id: 13, type: 13, name: '기타1', image: 'type-reagent.svg' },
				// { id: 14, type: 14, name: '기타2', image: 'type-pathogen.svg' },
			],
			msdsTypeList: [
				{ id: 1, type: 1, image: 'msds-icon1.svg' },
				{ id: 2, type: 2, image: 'msds-icon2.svg' },
				{ id: 3, type: 3, image: 'msds-icon3.svg' },
				{ id: 4, type: 4, image: 'msds-icon4.svg' },
				{ id: 5, type: 5, image: 'msds-icon5.svg' },
				{ id: 6, type: 6, image: 'msds-icon6.svg' },
				{ id: 7, type: 7, image: 'msds-icon7.svg' },
			],
		}
	},
	methods: {
		matchTypeToImage(item) {
			for (let i = 0; i < this.typeList.length; i++) {
				if (item == this.typeList[i].type) {
					return this.typeList[i].image
				}
			}
		},
		matchSafetyTypeToImage(item) {
			for (let i = 0; i < this.msdsTypeList.length; i++) {
				if (item == this.msdsTypeList[i].type) {
					return this.msdsTypeList[i].image
				}
			}
		},
		categoryToImage(type) {
			return categoryToImage(type)
		},
		findFirstName(name) {
			return name.charAt(0)
		},
		show() {
			this.isShow = true
		},
		hide() {
			this.isShow = false
		},
		fold(folded) {
			this.folded = folded
		},
		modalOpen() {
			document.body.classList.add('modal-open')
		},
		modalHide() {
			document.body.classList.remove('modal-open')
		},
		isNotice(list) {
			let arr = []

			for (let item of list) {
				arr.push(item.status)
			}

			let count = 0
			for (let i = 0; i < arr.length; i++) {
				if (arr[i] == 'UNSAFE') {
					count++
				}
			}

			return count
		},
	},
}
